<template>
  <div class="yt-widget">
    <span class="yt-widget__icon">
      <v-icon size="28">mdi-youtube</v-icon>
    </span>
    <span class="yt-widget__text">
      <span class="yt-widget__count">{{ formattedCount }}</span>
      <span class="yt-widget__label">INSCRITOS</span>
    </span>
    <v-tooltip bottom color="surface_neutral_selected">
      <template v-slot:activator="{ on, attrs }">
        <div class="yt-widget__switch" v-bind="attrs" v-on="on">
          <v-switch
            v-model="exibirNaTarja"
            hide-details
            dense
            color="primary"
            :aria-label="exibirNaTarja ? 'Remover inscritos do YouTube da tarja' : 'Exibir inscritos do YouTube na tarja'"
            @change="onSwitchChange"
          />
        </div>
      </template>
      <span>{{ exibirNaTarja ? "Remover da Tarja" : "Exibir na Tarja" }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { apiClient } from "@/services/api";

export default {
  name: "YoutubeSubscriberCounter",
  props: {
    codProducao: { type: Number, required: true },
    numInscritosYoutube: { type: Number, default: null },
    flgExibirInscritosTarja: { type: Boolean, default: false },
  },
  data() {
    return {
      exibirNaTarja: false,
    };
  },
  computed: {
    formattedCount() {
      const n = this.numInscritosYoutube;
      if (n === null || n === undefined) return "—";
      if (n >= 1_000_000) {
        return `${(n / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`;
      }
      if (n >= 1_000) {
        return `${(n / 1_000).toFixed(1).replace(/\.0$/, "")}K`;
      }
      return String(n);
    },
  },
  mounted() {
    this.exibirNaTarja = this.flgExibirInscritosTarja || false;
  },
  watch: {
    flgExibirInscritosTarja(newVal) {
      this.exibirNaTarja = newVal;
    },
  },
  methods: {
    async onSwitchChange(newValue) {
      this.$emit("toggle-tarja-display", newValue);
      try {
        await apiClient.patch("/atualizarConfigTarja", {
          cod_producao: this.codProducao,
          flg_exibir_inscritos_youtube: newValue,
        });
      } catch (error) {
        console.error("[YoutubeSubscriberCounter] Error updating database:", error);
        // Rollback optimistic UI on failure
        this.$nextTick(() => {
          this.exibirNaTarja = !newValue;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.yt-widget {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 6px 8px 6px 12px;
  background: var(--v-surface_secondary-base);
  border: 1px solid var(--sc-border-default);
  border-radius: var(--sc-radius-md);
}

.yt-widget__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  .v-icon {
    color: #ff0000 !important;
  }
}

.yt-widget__text {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.1;
  margin-right: 4px;
}

.yt-widget__count {
  font-size: 1rem;
  font-weight: var(--sc-weight-bold);
  color: var(--v-text_primary-base);
  letter-spacing: 0;
}

.yt-widget__label {
  font-size: 0.65rem;
  font-weight: var(--sc-weight-medium);
  color: var(--v-text_secondary-base);
  text-transform: uppercase;
  letter-spacing: var(--sc-tracking-caps);
  margin-top: 2px;
}

.yt-widget__switch {
  display: inline-flex;
  align-items: center;

  // Trim the default v-switch padding so it sits tight against the count
  ::v-deep .v-input--switch {
    margin: 0;
    padding: 0;
  }
  ::v-deep .v-input__slot {
    margin: 0;
  }
  ::v-deep .v-messages {
    display: none;
  }
}
</style>
